import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FileCopyOutlined } from '@material-ui/icons';
import { Button, Card } from '@material-ui/core';
import { connect } from 'react-redux';
/********** COMPONENTS **********/
import TitleWithIconBar from 'component/TitleWithIcon';
import LoadingSpinner from 'component/LoadingSpinner';
import AlertElement from 'component/AlertElement';
import Form from "component/Form/FormTwoColumns";
/********** SERVICES **********/
import ApiServices from 'service/ApiServices';
import { functions } from 'constant';
/********** REDUX **********/
import mapDispatchToProps from './mapDispatchToProps';
import mapStateToProps from './mapStateToProps';
/********** STYLES **********/
import { useStyles } from './style';


const ReporteOPASAM = (props) => {
    /********** VARIABLES **********/
    const dataOPRedux = props.dataOP;
    const currentUser = props.currentUser;
    const classes = useStyles();
    const controller = 'reportesGenerales';
    const tipoOrganizacionNac = [
        {id: 3, name: "NACIONAL"},
        {id: 2, name: "DEPARTAMENTAL"}, 
    ];
    const [elementAlertModal, setElementAlertModal] = useState({openAlert: false, titleAlert: '', typeAlert: '' }),
    [loadingSpinner, setLoadingSpinner] = useState({openLoading: false, message: ''}),
    [elements, setElements] = useState({        
        tipoOrganizacion: {
            idelement: "tipoOrganizacion", value: null, label:"Seleccione el tipo de Órgano Político", pattern: "^[0-9]*$", 
            validators: 'required', isError: false, errorMessages: ["Debe seleccionar el tipo de órgano"], 
            elementType: 'autocompleteV2', list: tipoOrganizacionNac, showSelectAutoComplete: true, disabled: false, handler: handleChangeTypeOrganization 
        },
        idDepartamento: {
            idelement: "idDepartamento", value: null , label: "Seleccione el departamento *", pattern:"^[0-9]*$", validators: '',
            errorMessages:['Seleccione el departamento'], isError:false, elementType:'autocompleteV2', list: [], handler: undefined,
            showSelectAutoComplete: false, disabled: false
        }
    });

/********** FUNCTIONS **********/
    useEffect(() => {
        getDepartamentData();
    },[])

    /* Función para obtener el listado de las organizaciones políticas para mostrarlas en el select */
    const getDepartamentData = useCallback(async () => {
        try {
            setLoadingSpinner({...loadingSpinner, openLoading: true, message: 'Obteniendo datos de los Departamentos...'});
            let response = await ApiServices.departamentos.listRegisterPublic();
            if(response.error !== null){
                setElementAlertModal({...elementAlertModal, openAlert: true, titleAlert: response.error.message, 
                    typeAlert: 'error' });
            } else {
                let dataDepartament = response.data.filter((_, index) => ![22, 23, 24].includes(index));
                let newDataDepartament = [...dataDepartament];
                elements.idDepartamento.list = newDataDepartament;
            }
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        } catch (exception) {
            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', 
                titleAlert: 'Error al obtener los datos de Departamentos' + exception + ', consulte con soporte.'});
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        }
    },[]);

    /* Función para habilitar los Inputs de Departamento y Municipio según el tipo de Organización */
    function handleChangeTypeOrganization(){
        let newElements = Object.assign({}, elements);
        /* Reportes NACIONALES */
        if (elements.tipoOrganizacion.value.id === 1){
            newElements.idDepartamento.showSelectAutoComplete = false;
            newElements.idDepartamento.value = null;
        /* Reportes Departamentales */
        } else if (elements.tipoOrganizacion.value.id === 2){
            newElements.idDepartamento.handler = undefined;
            newElements.idDepartamento.showSelectAutoComplete = true;
            newElements.idDepartamento.value = null;
        }
        setElements(newElements);
    }

    /* Función para obtener reportes según los parametros seleccionados */
    async function generateReport(){
        try {
            if(elements.tipoOrganizacion.value === null){
                setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'warning', 
                    titleAlert: 'Seleccione primero todos los campos.'});
            } else {
                const valueOP = dataOPRedux;
                setLoadingSpinner({ ...loadingSpinner, openLoading: true, message: 'Generando reporte...' }); 
                const hasPermission = await ApiServices.userSecurity.hasPermission(controller, "reporteOPASAM");
                if (hasPermission.error) {
                    setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'warning', 
                        titleAlert: 'Permisos Insuficientes'});
                    setLoadingSpinner({ ...loadingSpinner, openLoading: false});
                } else {
                    let data = {tipoReporte: 1, idOP: valueOP.idOrganizacion, tipoOpasam: 1, 
                        tipoOrganizacion: elements.tipoOrganizacion.value.id, externo: 1, usuario: currentUser.userName};
                    let titleDocument = 'Reporte OPASAM ' + valueOP.name + ' ' +  elements.tipoOrganizacion.value.name;

                    if(elements.tipoOrganizacion.value.id === 1){
                        /* REPORTE NACIONAL */
                        if(data.departamentoReporte){
                            delete data.departamentoReporte;
                        }
                    } else if (elements.tipoOrganizacion.value.id === 2) {
                        /* REPORTE DEPARTAMENTAL */
                        if(elements.idDepartamento.value === null){
                            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'warning', 
                        titleAlert: 'Seleccione todos los campos'});
                        setLoadingSpinner({ ...loadingSpinner, openLoading: false});                 
                        return;
                        } else {
                            data.departamentoReporte = elements.idDepartamento.value.id === 0 ? "" : 
                            elements.idDepartamento.value.id;
                        }
                    }
                    let response = await ApiServices.reportesGenerales.getReporteOPASAM(data);
                    if(response.error !== null){
                        var messageError = JSON.parse(response.error.message);
                        setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', titleAlert: messageError.message});
                    } else {
                        functions.downloadPDFFromStringBase64(response.data.data, titleDocument);
                    }  
                    setLoadingSpinner({ ...loadingSpinner, openLoading: false});                 
                }
            }
        } catch (exception) {
            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', 
                titleAlert: 'Error al generar el reporte' + exception + ', consulte con soporte.'});
            setLoadingSpinner({ ...loadingSpinner, openLoading: false});
        }
    }

    /*  El método cierra el "AlertElement" que muestra los modales de alertas, se ejecuta desde el "AlertElement" */
    const handCloseModal = () => {
        setElementAlertModal({...elementAlertModal, openAlert: false})
    }
    
/********** RENDER **********/
    return (
        <div className={classes.root}>
            {loadingSpinner.openLoading && <LoadingSpinner open={loadingSpinner.openLoading} message={loadingSpinner.message}/>}
            {elementAlertModal.openAlert && <AlertElement typeAlert={elementAlertModal.typeAlert} openModal={elementAlertModal.openAlert} 
                title={elementAlertModal.titleAlert} handCloseModal={handCloseModal} />}
            <TitleWithIconBar title="Reporte OPASAM" icon={"/menu/Constancia.png"} />
            <div className={classes.cardMainContainer}>
                <Card className={classes.cardContainer}>
                    <div className={classes.searchContainer}>
                        <Form elements={elements} />
                    </div>           
                    <div className={classes.buttonContainer}>
                        <Button className={classes.buttonSearch} onClick={generateReport} variant='outlined' startIcon={<FileCopyOutlined/>}>
                            BUSCAR
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(ReporteOPASAM);